export default __webpack_public_path__ + "locales/vi/RoomLogoCover.json?hash=a05b37d48741a84adc8530bd02f51711";